var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalIconOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16667 11.0834C3.16667 6.7111 6.71108 3.16669 11.0833 3.16669H26.9167C31.2889 3.16669 34.8333 6.7111 34.8333 11.0834V26.9167C34.8333 31.2889 31.2889 34.8334 26.9167 34.8334H11.0833C6.71108 34.8334 3.16667 31.2889 3.16667 26.9167V11.0834ZM11.0833 6.33335C8.45998 6.33335 6.33333 8.46 6.33333 11.0834V26.9167C6.33333 29.54 8.45998 31.6667 11.0833 31.6667H26.9167C29.54 31.6667 31.6667 29.54 31.6667 26.9167V11.0834C31.6667 8.46 29.54 6.33335 26.9167 6.33335H11.0833Z",
    fill: "#00B0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.347 13.0336C27.0187 13.5935 27.1095 14.5919 26.5497 15.2636L18.633 24.7636C18.3566 25.0953 17.9567 25.2997 17.526 25.3296C17.0953 25.3594 16.6711 25.212 16.3516 24.9216L11.6016 20.6034C10.9546 20.0152 10.9069 19.0138 11.4951 18.3668C12.0833 17.7197 13.0847 17.672 13.7317 18.2602L17.2586 21.4665L24.117 13.2364C24.6768 12.5646 25.6752 12.4738 26.347 13.0336Z",
    fill: "#00B0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconOk);
export default __webpack_public_path__ + "static/media/modal-icon-ok.0a68db5a260b4509c6770caf9e5595f5.svg";
export { ForwardRef as ReactComponent };